import { __extends } from "tslib";
import { CreateBucketOutput, CreateBucketRequest } from "../models/models_0";
import { deserializeAws_restXmlCreateBucketCommand, serializeAws_restXmlCreateBucketCommand, } from "../protocols/Aws_restXml";
import { getLocationConstraintPlugin } from "@aws-sdk/middleware-location-constraint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var CreateBucketCommand = /** @class */ (function (_super) {
    __extends(CreateBucketCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function CreateBucketCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    CreateBucketCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getLocationConstraintPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "CreateBucketCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: CreateBucketRequest.filterSensitiveLog,
            outputFilterSensitiveLog: CreateBucketOutput.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CreateBucketCommand.prototype.serialize = function (input, context) {
        return serializeAws_restXmlCreateBucketCommand(input, context);
    };
    CreateBucketCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlCreateBucketCommand(output, context);
    };
    return CreateBucketCommand;
}($Command));
export { CreateBucketCommand };
//# sourceMappingURL=CreateBucketCommand.js.map